import { render } from "./snackbar.vue?vue&type=template&id=5eff573e"
import script from "./snackbar.vue?vue&type=script&lang=js"
export * from "./snackbar.vue?vue&type=script&lang=js"

import "./snackbar.vue?vue&type=style&index=0&id=5eff573e&lang=css"

import exportComponent from "/Users/basil/Documents/rishad/ncp_form/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__